// Shared straightener constants — single source for values that more than one
// screen renders.

// Operating crews for recipe ownership/filtering.
export const CREWS = ["A", "B", "C", "D"] as const;

// Height of the controls sharing the banner row (recipe picker + its action
// buttons). MUI's own "small" sizes disagree — a small Autocomplete lands near
// 37px and a small Button near 31px — so both sides are pinned here rather than
// letting one chase the other.
export const BANNER_CONTROL_HEIGHT = 36;

// "IN PLC" indicators and the SET PLC CURRENT action stay hidden until the
// parked Send-to-PLC backend is restored (docs/features/straightener/
// parked-send-to-plc). Flip to show — the backend flag is kept either way.
export const SHOW_IN_PLC = false;
